// 網路相關設定
let imgaddress = process.env.VUE_APP_IMAGES_FROM_APACHE_DOMAIN
let otpaddress = ''
let baseaddress = ''
let cardaddress = process.env.VUE_APP_IMAGES_FROM_CLIENT_DOMAIN
// ie 10 不支援 window.location.origin
if (!window.location.origin) {
  baseaddress = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
} else {
  baseaddress = window.location.origin
}
otpaddress = imgaddress

export const network = {
  // web 網址
  webAddress: baseaddress + '/active/#/',
  // api 網址
  baseAddress: baseaddress + '/api/active/',
  // 圖檔資源路徑
  imgAddress: imgaddress + '/active/image/',
  // aem卡圖路徑
  cardaddress,
  // 客製化 aem卡圖路徑
  customCardaddress: imgaddress + '/card/image',
  // otp路徑
  otpAddress: otpaddress + '/api/otp/init',
  // 連線逾時秒數
  timeout: 600,
  // otp 逾時秒數
  otpTimeout: 600
}
export default network
